jQuery(document).ready(function($) {
  if(window.innerWidth<768){
    $(".mobileSlider li").removeAttr("style");
    $('.mobileSlider').slick({
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        arrows: false,
        responsive: [{
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }]
    });
    $('.mobileSliderBlog').slick({
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        arrows: false,
        responsive: [{
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
           breakpoint: 400,
           settings: {
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1
           }
        }]
    });
  }
});

jQuery(window).on('resize load', function() {
  if(window.innerWidth>767){
    // var target = $('.mobileSlider');
    // if(target.hasClass('slick-initialized')) {
    //    target.unslick();  
    // }
  }  
});